import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-authoring-view',
  templateUrl: './authoring-view.component.html',
  styleUrls: ['./authoring-view.component.scss']
})
export class AuthoringViewComponent implements OnInit {
  adminData:any;tab:any;
  errorInfo:{isError:boolean,errorMsg:string} = {isError:false,errorMsg:''}
  content_capsule_id :any;data={};contentDetailsData:any;contentDetailsDatas:any=[];
  constructor(private contentAuthoringApi:ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
    this.route.queryParams.subscribe(queryParams => {
    this.content_capsule_id = queryParams['id'];
    this.tab = queryParams['tab'];
    this.getContentAuthDetails(this.content_capsule_id);
    });
    this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
  }
  getContentAuthDetails(content_capsule_id:any){
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthDetails(content_capsule_id).subscribe(
      (data)=>{
      if(data.success){
        this.spinner.hide();
        this.contentDetailsData=data.data;
        this.contentDetailsDatas=data.data.contentCapsuleMedia;  
        //console.log('conent',this.contentDetailsData);
      }else{
        this.spinner.hide();
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'No data Exist'
      }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
       },
    );
  }
  getMediaType(mediatypeArr:any,media_type:any){
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
  }
  logout(){
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   } 
}
